import { render, staticRenderFns } from "./BreakInfinityModal.vue?vue&type=template&id=5d84c8c4&"
import script from "./BreakInfinityModal.vue?vue&type=script&lang=js&"
export * from "./BreakInfinityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports